<template>
  <div>
    <b-row>
      <b-col cols="3">
        <!-- 柔性指标 -->
        <b-card style="height: 18rem">
          <b-card-title class="text-truncate"> 柔性指标 </b-card-title>
          <b-card-text>
            <b-row>
              <!-- <b-col cols="12">
                <div id="container_gauge" style="height: 15rem" class="mb-1"></div>
              </b-col> -->

              <b-col cols="6">
                <b-alert show variant="primary">
                  <div class="alert-body d-flex align-items-center" style="gap: 1rem">
                    <b-icon-slack font-scale="1.5" />
                    <div>
                      <div class="my-25">温度调控柔度</div>
                      <div>
                        <!-- <span class="font-digit text-truncate" style="font-size: 1.5rem">{{ flexibility.fh }}</span> -->
                        <span class="font-digit text-truncate" style="font-size: 1.5rem">15.6</span>
                        <label class="ml-25">%</label>
                      </div>
                    </div>
                  </div>
                </b-alert>
              </b-col>

              <b-col cols="6">
                <b-alert show variant="success">
                  <div class="alert-body d-flex align-items-center" style="gap: 1rem">
                    <b-icon-compass font-scale="1.5" />
                    <div>
                      <div class="my-25">输配柔度</div>
                      <div>
                        <!-- <span class="font-digit text-truncate" style="font-size: 1.5rem">{{ flexibility.ps }}</span> -->
                        <span class="font-digit text-truncate" style="font-size: 1.5rem">20.5</span>
                        <label class="ml-25">%</label>
                      </div>
                    </div>
                  </div>
                </b-alert>
              </b-col>

              <b-col cols="6">
                <b-alert show variant="warning" class="mb-0">
                  <div class="alert-body d-flex align-items-center" style="gap: 1rem">
                    <b-icon-cpu font-scale="1.5" />
                    <div>
                      <div class="my-25">供能系统柔度</div>
                      <div>
                        <!-- <span class="font-digit text-truncate" style="font-size: 1.5rem">{{ flexibility.gnxt }}</span> -->
                        <span class="font-digit text-truncate" style="font-size: 1.5rem">18.2</span>
                        <label class="ml-25">%</label>
                      </div>
                    </div>
                  </div>
                </b-alert>
              </b-col>

              <b-col cols="6">
                <b-alert show variant="danger" class="mb-0">
                  <div class="alert-body d-flex align-items-center" style="gap: 1rem">
                    <b-icon-battery-charging font-scale="1.5" />
                    <div>
                      <div class="my-25">储能设备柔度</div>
                      <div>
                        <!-- <span class="font-digit text-truncate" style="font-size: 1.5rem">{{ flexibility.cnsb }}</span> -->
                        <span class="font-digit text-truncate" style="font-size: 1.5rem">14.7</span>
                        <label class="ml-25">%</label>
                      </div>
                    </div>
                  </div>
                </b-alert>
              </b-col>

              <!-- <b-col cols="6">
                <b-alert show variant="info">
                  <div class="alert-body d-flex align-items-center" style="gap: 1rem">
                    <b-icon-wind font-scale="1.5" />
                    <div>
                      <div class="my-25">末端设备柔度</div>
                      <div>
                        <span class="font-digit text-truncate" style="font-size: 1.5rem">{{ flexibility.mdsb }}</span>
                        <label class="ml-25">%</label>
                      </div>
                    </div>
                  </div>
                </b-alert>
              </b-col> -->
            </b-row>
          </b-card-text>
        </b-card>

        <!-- 控制参数 -->
        <b-card style="position: relative; height: 18rem">
          <b-card-title class="text-truncate"> 控制参数 </b-card-title>
          <v-select
            v-model="controlSelect"
            placeholder="设备"
            :options="deviceList"
            :clearable="false"
            label="eqname"
            @input="handleControlSelect"
            class="select"
          />

          <b-card-text>
            <b-row>
              <b-col cols="6">
                <label>开关状态</label>
                <div>
                  <b-form-checkbox v-model="controlParams.checked" name="check-button" switch inline :disabled="operationMode != 1">
                    {{ controlParams.checked ? '开' : '关' }}</b-form-checkbox
                  >
                </div>
              </b-col>
              <b-col cols="6">
                <label>风速挡位</label>
                <b-form-radio-group v-model="controlParams.radio" :disabled="operationMode != 1">
                  <b-form-radio value="3"> 高 </b-form-radio>
                  <b-form-radio value="2"> 中 </b-form-radio>
                  <b-form-radio value="1"> 低 </b-form-radio>
                </b-form-radio-group>
              </b-col>
            </b-row>
            <b-row class="mt-1">
              <b-col cols="6">
                <label>温度设定</label>
                <b-input-group class="temp_inp">
                  <b-form-input v-model="controlParams.wdsd" :disabled="operationMode != 1" type="number" placeholder="温度设定"></b-form-input>
                  <b-input-group-append :class="{ disabled_custom: operationMode != 1 }">
                    <b-input-group-text>℃</b-input-group-text>
                  </b-input-group-append>
                </b-input-group>
              </b-col>
              <b-col cols="6">
                <label>运行模式</label>
                <v-select
                  v-model="controlParams.yxms"
                  label="title"
                  :reduce="(val) => val.value"
                  :disabled="operationMode != 1"
                  placeholder="运行模式"
                  :options="modeOptions"
                />
              </b-col>
            </b-row>
            <!-- <b-row class="mt-1">
              <b-col cols="6">
                <b-form-input v-model="controlParams.rymd" placeholder="人员密度" />
              </b-col>
              <b-col cols="6">
                <v-select v-model="controlParams.ryzsl" label="title" placeholder="人员在室率" :options="occupancyOptions" />
              </b-col>
            </b-row> -->
          </b-card-text>
          <div class="d-flex justify-content-end" style="gap: 1rem">
            <b-btn size="sm" variant="outline-primary" @click="reset" :disabled="operationMode != 1">重置</b-btn>
            <b-btn size="sm" variant="primary" @click="submit" :disabled="btnLoading || operationMode != 1">设定</b-btn>
          </div>
        </b-card>
      </b-col>

      <!-- 建筑图片 -->
      <b-col cols="6">
        <div style="height: 4rem">
          <h1 class="font-title text-center mb-0" style="font-size: 2rem; pointer-events: auto">公共建筑环境人因工程柔性调控系统</h1>
          <div class="text-center" style="pointer-events: auto">
            Human Factors Engineering Flexible Control System for Public Building Environments
          </div>
        </div>

        <div class="pt-50 pb-25 d-flex justify-content-between">
          <b-form-radio-group v-model="operationMode">
            <b-form-radio value="0"> 本地自动 </b-form-radio>
            <b-form-radio value="1"> 远程手动 </b-form-radio>
            <b-form-radio value="2"> 柔性调控 </b-form-radio>
          </b-form-radio-group>
          <b-form-checkbox v-model="showChart" @change="change" name="check-button" switch inline>
            {{ showChart ? 'Table' : 'Image' }}</b-form-checkbox
          >
        </div>
        <b-card v-show="showChart == true" style="height: 31.5rem">
          <b-tabs style="position: relative">
            <b-btn size="sm" variant="primary" @click="fetchGetList" style="position: absolute; top: 4px; right: 0">刷新</b-btn>
            <b-tab title="房间" @click="switchTabs(1)" active></b-tab>
            <b-tab title="主机" @click="switchTabs(2)"></b-tab>
            <div class="custom_table">
              <b-table :fields="fields" :items="items" :busy="loading" :no-border-collapse="true" sticky-header responsive style="height: 25rem">
                <template #table-busy>
                  <div class="text-center text-primary my-2">
                    <b-spinner class="align-middle"></b-spinner>
                    <strong>Loading...</strong>
                  </div>
                </template>
              </b-table>
            </div>
          </b-tabs>
        </b-card>
        <b-card
          v-show="showChart == false"
          style="
            height: 31.5rem;
            background-image: url(/images/flexibility.jpg);
            background-position: center center;
            background-size: cover;
            position: relative;
          "
        >
          <!-- <div style="position: absolute; top: 0; right: 0" class="pt-50 pr-1">
            <label>室外温度
              <span class="font-digit text-primary">{{ temperature }}</span>
              ℃
            </label>
            <label class="ml-2">室外湿度
              <span class="font-digit text-primary">{{ humidity }}</span>
              %
            </label>
          </div> -->
        </b-card>
      </b-col>

      <b-col cols="3">
        <!-- 室外环境 -->
        <b-card style="position: relative; height: 11rem">
          <b-card-title class="text-truncate">室外环境</b-card-title>

          <b-card-text>
            <b-row>
              <b-col cols="6">
                <b-alert show variant="info" class="mb-0">
                  <div class="alert-body d-flex justify-content-between align-items-center" style="gap: 1rem">
                    <b-avatar variant="light-info">
                      <b-icon-thermometer />
                    </b-avatar>
                    <div class="text-right">
                      <div class="font-digit" style="font-size: 1.5rem">{{ temperature }}</div>
                      <label>温度 (℃)</label>
                    </div>
                  </div>
                </b-alert>
              </b-col>

              <b-col cols="6">
                <b-alert show variant="info" class="mb-0">
                  <div class="alert-body d-flex justify-content-between align-items-center" style="gap: 1rem">
                    <b-avatar variant="light-info">
                      <b-icon-droplet-half />
                    </b-avatar>
                    <div class="text-right">
                      <div class="font-digit" style="font-size: 1.5rem">{{ humidity }}</div>
                      <label>湿度 (%)</label>
                    </div>
                  </div>
                </b-alert>
              </b-col>
            </b-row>
          </b-card-text>
        </b-card>

        <!-- 室内环境 -->
        <b-card style="position: relative; height: 25rem">
          <b-card-title class="text-truncate">室内环境</b-card-title>

          <!-- <b-badge style="position: absolute; top: 1rem; left: 7rem;"
            :variant="indoorEnvironment.comfort == '舒适' ? 'light-success' : indoorEnvironment.comfort == '稍暖' ? 'light-warning' : 'light-danger'">舒适</b-badge> -->

          <v-select
            v-model="indoorSelect"
            placeholder="设备"
            :options="deviceList"
            :clearable="false"
            label="eqname"
            @input="handleIndoorSelect"
            class="select"
          />

          <b-card-text>
            <b-row>
              <b-col cols="6">
                <b-alert show variant="primary">
                  <div class="alert-body d-flex justify-content-between align-items-center" style="gap: 1rem">
                    <b-avatar variant="light-primary">
                      <b-icon-thermometer />
                    </b-avatar>
                    <div class="text-right">
                      <div class="font-digit" style="font-size: 1.5rem">{{ indoorEnvironment.wd }}</div>
                      <label>温度 (℃)</label>
                    </div>
                  </div>
                </b-alert>
              </b-col>

              <b-col cols="6">
                <b-alert show variant="primary">
                  <div class="alert-body d-flex justify-content-between align-items-center" style="gap: 1rem">
                    <b-avatar variant="light-primary">
                      <b-icon-droplet-half />
                    </b-avatar>
                    <div class="text-right">
                      <div class="font-digit" style="font-size: 1.5rem">{{ indoorEnvironment.sd }}</div>
                      <label>湿度 (%)</label>
                    </div>
                  </div>
                </b-alert>
              </b-col>

              <b-col cols="6">
                <b-alert show variant="primary">
                  <div class="alert-body d-flex justify-content-between align-items-center" style="gap: 1rem">
                    <b-avatar variant="light-primary">
                      <b-icon-share />
                    </b-avatar>
                    <div class="text-right">
                      <div class="font-digit" style="font-size: 1.5rem">{{ indoorEnvironment.co2 }}</div>
                      <label>CO2 (ppm)</label>
                    </div>
                  </div>
                </b-alert>
              </b-col>

              <b-col cols="6">
                <b-alert show variant="primary">
                  <div class="alert-body d-flex justify-content-between align-items-center" style="gap: 1rem">
                    <b-avatar variant="light-primary">
                      <b-icon-asterisk />
                    </b-avatar>
                    <div class="text-right">
                      <div class="font-digit" style="font-size: 1.5rem">{{ indoorEnvironment.pm25 }}</div>
                      <label>PM2.5 (μg/m3)</label>
                    </div>
                  </div>
                </b-alert>
              </b-col>

              <b-col cols="6">
                <b-alert show variant="warning">
                  <div class="alert-body d-flex justify-content-between align-items-center" style="gap: 1rem">
                    <b-avatar variant="light-warning">
                      <b-icon-compass font-scale="1.5" />
                    </b-avatar>
                    <div class="text-right">
                      <div class="font-digit" style="font-size: 1.5rem">{{ indoorEnvironment.pmv }}</div>
                      <label>PMV</label>
                    </div>
                  </div>
                </b-alert>
              </b-col>

              <b-col cols="6">
                <b-alert show variant="warning">
                  <div class="alert-body d-flex justify-content-between align-items-center" style="gap: 1rem">
                    <b-avatar variant="light-warning">
                      <b-icon-compass font-scale="1.5" />
                    </b-avatar>
                    <div class="text-right">
                      <div class="font-digit" style="font-size: 1.5rem">{{ indoorEnvironment.ppd }}</div>
                      <label>PPD (%)</label>
                    </div>
                  </div>
                </b-alert>
              </b-col>

              <!-- <b-col cols="6">
                <div class="d-flex align-items-center justify-content-between">
                  <b-avatar variant="light-success">
                    <b-icon-percent />
                  </b-avatar>
                  <div class="text-right">
                    <div class="font-digit" style="font-size: 1.5rem">{{ indoorEnvironment.kqjhzs }}</div>
                    <label>空气净化指数 (%)</label>
                  </div>
                </div>
              </b-col> -->
            </b-row>

            <div class="d-flex" style="gap: 0.5rem">
              <label>室内热舒适</label>
              <b-badge
                :variant="
                  indoorEnvironment.comfort == '舒适' ? 'light-success' : indoorEnvironment.comfort == '稍暖' ? 'light-warning' : 'light-danger'
                "
                >{{ indoorEnvironment.comfort }}</b-badge
              >
            </div>
          </b-card-text>
        </b-card>
      </b-col>
    </b-row>

    <b-row>
      <!-- 负荷预测 -->
      <b-col cols="4">
        <b-card style="height: 22rem">
          <b-card-title class="text-truncate"> 负荷预测 </b-card-title>
          <div id="container_area" style="height: 16rem"></div>
          <div class="position-absolute" style="bottom: 4.2rem; left: 5rem">
            今日预计最大负荷
            {{ predictionMax.egname ? '(' + predictionMax.egname.replace('预测', '') + ')' : '' }}
            <b-badge variant="light-danger">{{ predictionMax.value || '0' }}</b-badge>
            <small> kW @ {{ predictionMax.time || '00:00' }}</small>
          </div>
        </b-card>
      </b-col>

      <b-col cols="4">
        <b-card style="height: 22rem">
          <b-card-title class="text-truncate"> 柔性调控 </b-card-title>
          <div id="container_dualAxes" style="height: 16rem"></div>
        </b-card>
      </b-col>

      <b-col cols="4">
        <b-card style="height: 22rem">
          <b-card-title class="text-truncate"> 温度设定 </b-card-title>
          <b-card-text>
            <div id="container_line" style="height: 16rem"></div>
          </b-card-text>
        </b-card>
        <!-- <b-card style="height: 22rem">
          <b-card-title class="text-truncate"> 储能调度 </b-card-title>
          <b-card-text>
            <b-row>
              <b-col cols="4">
                <div class="d-flex align-items-center justify-content-between">
                  <b-avatar variant="light-warning">
                    <b-icon-battery-charging scale="1.5" />
                  </b-avatar>
                  <div class="text-right">
                    <div class="font-digit" style="font-size: 1.5rem">{{ storedEnergy.charging }}</div>
                    <div class="font-digit" style="font-size: 1.5rem">10.2</div>
                    <label>当日充电量 (kWh)</label>
                  </div>
                </div>
              </b-col>
              <b-col cols="2"></b-col>
              <b-col cols="4">
                <div class="d-flex align-items-center justify-content-between">
                  <b-avatar variant="light-warning">
                    <b-icon-battery-half scale="1.5" />
                  </b-avatar>
                  <div class="text-right">
                    <div class="font-digit" style="font-size: 1.5rem">{{ storedEnergy.discharge }}</div>
                    <div class="font-digit" style="font-size: 1.5rem">4.5</div>
                    <label>当日放电量 (kWh)</label>
                  </div>
                </div>
              </b-col>
            </b-row>
            <div id="container_stackedColumn" style="height: 12rem"></div>
          </b-card-text>
        </b-card> -->
      </b-col>

      <!-- <b-col cols="3" >
        <b-card style="height: 22rem">
          <b-card-title class="text-truncate"> 优化成效 </b-card-title>
          <b-card-text>
            <b-row>
              <b-col cols="6">
                <b-alert show variant="danger">
                  <div class="alert-body d-flex align-items-center" style="gap: 1rem">
                    <b-icon-lightning-charge font-scale="1.5" />
                    <div>
                      <div class="font-digit" style="font-size: 1.5rem">{{ optimizing.conservation }}</div>
                      <label>节能效益 (kWh)</label>
                    </div>
                  </div>
                </b-alert>
              </b-col>
              <b-col cols="6">
                <b-alert show variant="danger">
                  <div class="alert-body d-flex align-items-center" style="gap: 1rem">
                    <b-icon-lightning-fill font-scale="1.5" />
                    <div>
                      <div class="font-digit" style="font-size: 1.5rem">{{ optimizing.adjust }}</div>
                      <label>柔性调节量 (kWh)</label>
                    </div>
                  </div>
                </b-alert>
              </b-col>
              <div id="container_pie" style="height: 10rem"></div>
            </b-row>
          </b-card-text>
        </b-card>
      </b-col> -->
    </b-row>
  </div>
</template>

<script>
import store from '@/store';
import { Gauge, Area, DualAxes, Line, Column, Pie } from '@antv/g2plot';
import vSelect from 'vue-select';
import Prediction from '../common/project-detail/components/dashboard/components/Prediction.vue';
import {
  getFlexibilityIndex,
  getDeviceList,
  getParams,
  createParams,
  getTemperature,
  getIndoor,
  getEnvironment,
  getLoad,
  getControl,
  getStored,
  getOptimizing,
  getList,
} from '@/api/flexibility';
import { routerParams } from '@/libs/utils/routerParams';
import { showToast } from '@/libs/utils/showToast';

export default {
  components: {
    vSelect,
    Prediction,
  },
  data() {
    return {
      flexibility: {
        fh: '00.0',
        ps: '00.0',
        gnxt: '00.0',
        cnsb: '00.0',
        // mdsb: '00.0',
      },
      controlParams: {
        checked: false,
        radio: '2',
        wdsd: null,
        yxms: null,
        // rymd: null,
        // ryzsl: null,
      },
      loading: false,
      fields: [],
      items: [],
      roomsFields: [
        { key: 'eqnme', label: '房间' },
        { key: 'TR', label: '温度 (℃)', formatter: (value) => (value ? (value / 10).toFixed(1) : '--') },
        { key: 'HR', label: '湿度 (%)', formatter: (value) => (value ? (value / 10).toFixed(1) : '--') },
        { key: 'TL', label: '露点 (℃)', formatter: (value) => (value ? (value / 10).toFixed(1) : '--') },
        { key: 'TR2', label: '外侧温度 (℃)', formatter: (value) => (value ? (value / 10).toFixed(1) : '--') },
        { key: 'onoff', label: '开关' },
        { key: 'way', label: '模式' },
        { key: 'TS', label: '设定温度 (℃)' },
        { key: 'HS', label: 'HS' },
      ],
      roomsItems: [],
      masterFields: [
        { key: 'params', label: '参数名称' },
        { key: 'paraphrase', label: '中文名称' },
        { key: 'num', label: '数值' },
      ],
      masterItems: [
        { params: 'air_status', paraphrase: '系统运行状态', num: null },
        { params: 'board_temp', paraphrase: '板换温度', num: null },
        { params: 'chushuang', paraphrase: '除霜条件', num: null },
        { params: 'cid', paraphrase: '网关ID', num: null },
        { params: 'CO2', paraphrase: '二氧化碳', num: null },
        { params: 'cold_in_temp', paraphrase: '制冷剂进口温度', num: null },
        { params: 'coldWaterTemp', paraphrase: '制冷出水温度', num: null },
        { params: 'coldWindTemp', paraphrase: '制冷出风温度', num: null },
        { params: 'formaldehyde', paraphrase: '甲醛浓度', num: null },
        { params: 'hotWaterTemp', paraphrase: '制热出水温度', num: null },
        { params: 'hotWindTemp', paraphrase: '制热出风温度', num: null },
        { params: 'HR', paraphrase: '湿度（显示/10）', num: null },
        { params: 'huiqi_temp', paraphrase: '回气温度', num: null },
        { params: 'humi_dev_status', paraphrase: '加湿状态 （0：待机，1：运行）', num: null },
        { params: 'humi_dev_type', paraphrase: '加湿开关控制（1：强制运行，2：强制关闭）', num: null },
        { params: 'humiMaxSet', paraphrase: '湿度上限设置', num: null },
        { params: 'humiMinSet', paraphrase: '湿度下限设置', num: null },
        { params: 'in_chushuang', paraphrase: '内机除霜条件', num: null },
        { params: 'in_water_temp', paraphrase: '回水温度', num: null },
        { params: 'inhotoutwindtemp', paraphrase: '内换热器出风温度', num: null },
        { params: 'inhotwindtemp', paraphrase: '内换热器进风温度', num: null },
        { params: 'intubetemp', paraphrase: '内管温度', num: null },
        { params: 'inwind_high', paraphrase: '送风机风量设置，高速', num: null },
        { params: 'inwind_low', paraphrase: '送风机风量设置，中速', num: null },
        { params: 'inwind_mid', paraphrase: '送风机风量设置，低速', num: null },
        { params: 'inwindtemp', paraphrase: '进风温度', num: null },
        { params: 'kind', paraphrase: '设备类型', num: null },
        { params: 'l1_filter_days', paraphrase: '初效滤网剩余寿命', num: null },
        { params: 'l2_filter_days', paraphrase: '中效滤网剩余寿命', num: null },
        { params: 'l3_filter_days', paraphrase: '高效滤网剩余寿命', num: null },
        { params: 'modifyCo2', paraphrase: 'CO2修正值', num: null },
        { params: 'modifyTemp', paraphrase: '温度修正值', num: null },
        { params: 'onoff', paraphrase: '开关状态（0 -关闭，1-开机）', num: null },
        { params: 'out_chushuang', paraphrase: '外机除霜条件', num: null },
        { params: 'out_env_temp', paraphrase: '外部环境温度', num: null },
        { params: 'out_env_temp_wind', paraphrase: '', num: null },
        { params: 'out_mode_type', paraphrase: '离家模式季节设置 0-夏季(制冷) 1-冬季(制热)', num: null },
        { params: 'out_summer_closeTemp', paraphrase: '离家模式夏季关闭温度', num: null },
        { params: 'out_summer_openTemp', paraphrase: '离家模式夏季开启温度', num: null },
        { params: 'out_tube_temp', paraphrase: '外部管路温度', num: null },
        { params: 'out_tube_temp_wind', paraphrase: '', num: null },
        { params: 'out_water_temp', paraphrase: '出水温度', num: null },
        { params: 'out_wind_speed', paraphrase: '外风机转速', num: null },
        { params: 'out_wind_speed_wind', paraphrase: '', num: null },
        { params: 'out_winter_closeTemp', paraphrase: '离家模式冬季关闭温度', num: null },
        { params: 'out_winter_openTemp', paraphrase: '离家模式冬季开启温度', num: null },
        { params: 'outwind_high', paraphrase: '排风机风量设置，高速', num: null },
        { params: 'outwind_low', paraphrase: '排风机风量设置，低速', num: null },
        { params: 'outwind_mid', paraphrase: '排风机风量设置，中速', num: null },
        { params: 'outwindtemp', paraphrase: '排风温度', num: null },
        { params: 'PM25', paraphrase: 'PM2.5 浓度（单位：μg/m³）', num: null },
        { params: 'sendwindtemp', paraphrase: '送风温度', num: null },
        { params: 'speed', paraphrase: '风速档位（ 1-低风速 2-中风速 3-高风速 ）', num: null },
        { params: 'switchtemp', paraphrase: '交换器温度', num: null },
        { params: 'timestamp', paraphrase: '', num: null },
        { params: 'TR', paraphrase: '温度（显示/10）', num: null },
        { params: 'TS', paraphrase: '温度设定（显示/10）', num: null },
        { params: 'way', paraphrase: '主机模式（1-制热 2-制冷 3-送风 4-离家 5-除湿 6-新风制热）', num: null },
        { params: 'wj_status', paraphrase: '室外机系统运行状态', num: null },
        { params: 'ysj_in', paraphrase: '压缩机回气温度', num: null },
        { params: 'ysj_init', paraphrase: '压缩机启动条件', num: null },
        { params: 'ysj_init_wind', paraphrase: '', num: null },
        { params: 'ysj_out', paraphrase: '压缩机排气温度', num: null },
        { params: 'ysj_paiqi_temp', paraphrase: '压缩机排气温度', num: null },
        { params: 'ysj_speed', paraphrase: '压缩机转速', num: null },
        { params: 'ysj_speed_wind', paraphrase: '', num: null },
        { params: 'err_other', paraphrase: '其他故障代码', num: null },
        { params: 'err_other_wind', paraphrase: '', num: null },
        { params: 'err_sensor', paraphrase: '传感器故障代码', num: null },
        { params: 'err_sensor_wind', paraphrase: '', num: null },
        { params: 'err_signal1', paraphrase: '信号故障代码 1', num: null },
        { params: 'err_signal1_wind', paraphrase: '', num: null },
        { params: 'err_signal2', paraphrase: '信号故障代码 2', num: null },
        { params: 'err_signal2_wind', paraphrase: '', num: null },
        { params: 'error_code', paraphrase: '错误代码', num: null },
      ],
      deviceList: [],
      controlSelect: null,
      modeOptions: [
        { title: '制热', value: 1 },
        { title: '制冷', value: 2 },
        { title: '送风', value: 3 },
        { title: '离家', value: 4 },
        { title: '除湿', value: 5 },
        { title: '新风制热', value: 6 },
      ],
      occupancyOptions: [
        {
          title: '10%',
          value: 0.1,
        },
        {
          title: '20%',
          value: 0.2,
        },
        {
          title: '30%',
          value: 0.3,
        },
        {
          title: '40%',
          value: 0.4,
        },
        {
          title: '50%',
          value: 0.5,
        },
        {
          title: '60%',
          value: 0.6,
        },
        {
          title: '70%',
          value: 0.7,
        },
        {
          title: '80%',
          value: 0.8,
        },
        {
          title: '90%',
          value: 0.9,
        },
        {
          title: '100%',
          value: 1,
        },
      ],
      indoorSelect: null,
      indoorEnvironment: {
        wd: '--',
        sd: '--',
        co2: '--',
        pm25: '--',
        pmv: '--',
        ppd: '--',
        comfort: '',
        // kqjhzs: '00.0',
      },
      btnLoading: false,
      temperature: '--',
      humidity: '--',
      dialogueTemp: false,
      gaugePlot: null,
      areaPlot: null,
      dualAxesPlot: null,
      storedEnergy: {
        charging: '0.00',
        discharge: '0.00',
      },
      columnPlot: null,
      optimizing: {
        conservation: '0.00',
        adjust: '0.00',
      },
      piePlot: null,
      linePlot: null,
      predictionMax: { egname: '', value: 0, time: '' },
      operationMode: 0,
      showChart: false,
    };
  },
  watch: {},
  methods: {
    /**
     * 创建仪表盘
     */
    gaugePlotRender() {
      this.gaugePlot = new Gauge('container_gauge', {
        percent: 0,
        type: 'meter',
        innerRadius: 0.75,
        range: {
          ticks: [0, 1 / 3, 2 / 3, 1],
          color: ['#F4664A', '#FAAD14', '#30BF78'],
        },
        indicator: {
          pointer: {
            style: {
              stroke: '#D0D0D0',
            },
          },
          pin: {
            style: {
              stroke: '#D0D0D0',
            },
          },
        },
        statistic: {
          // content: {
          //   offsetY: 10,
          //   style: {
          //     fontSize: '1rem',
          //     color: "#4B535E",
          //   },
          //   formatter: () => '系统综合柔度',
          // },
        },
      });
      this.gaugePlot.render();
    },
    /**
     * 温度设定折线图
     */
    linePlotRender() {
      this.linePlot = new Line('container_line', {
        data: [],
        xField: 'time',
        yField: 'value',
        seriesField: 'category',
        xAxis: {},
        yAxis: {
          title: {
            text: '℃',
          },
          grid: null,
        },
        smooth: true,
      });
      this.linePlot.render();
    },
    /**
     * 创建负荷预测
     */
    areaPlotRender() {
      this.areaPlot = new Area('container_area', {
        color: ['#3B91FF', '#4AC76B', '#46D0EA'],
        legend: {
          itemName: {
            style: { fill: '#82868b' },
          },
          position: 'top',
        },
        data: [],
        xField: 'time',
        yField: 'value',
        seriesField: 'egname',
        isStack: false,
        xAxis: {
          range: [0, 1],
          label: {
            autoHide: true,
            autoRotate: false,
          },
          line: null,
          grid: null,
          tickLine: null,
          boundaryGap: false,
        },
        yAxis: {
          nice: true,
          grid: {
            line: {
              style: {
                stroke: '#82868b',
                lineWidth: 1,
                lineDash: [1, 6],
                strokeOpacity: 0.7,
              },
            },
          },
        },
        smooth: true,
        meta: {
          value: {
            alias: '数值',
            formatter: (value) => {
              return Math.round(value * 100) / 100;
            },
          },
        },
      });
      this.areaPlot.render();
    },
    /**
     * 创建柔性控制
     */
    dualAxesPlotRender() {
      this.dualAxesPlot = new DualAxes('container_dualAxes', {
        data: [[], []],
        xField: 'time',
        yField: ['windSpeedSet', 'temperSet'],
        // xAxis: {
        //   label: {
        //     formatter: (value) => value.split(' ')[1].substring(0, 5),
        //   },
        // },
        padding: [20, 22, 10, 20],
        yAxis: {
          windSpeedSet: {
            title: {
              text: '风速档位',
            },
            grid: null,
            min: 0,
            max: 3.25,
            sync: true, // 关键：确保同步
          },
          temperSet: {
            title: {
              text: '温度设定 (℃)',
            },
            grid: null,
            min: 0,
            sync: true, // 关键：确保同步
          },
        },
        geometryOptions: [
          {
            geometry: 'line',
          },
          {
            geometry: 'line',
            smooth: true,
          },
        ],
        meta: {
          windSpeedSet: {
            alias: '风速挡位',
          },
          temperSet: {
            alias: '温度设定',
          },
        },
      });
      this.dualAxesPlot.render();
    },
    /**
     * 创建柱状图
     */
    columnPlotRender() {
      this.columnPlot = new Column('container_stackedColumn', {
        data: [],
        isStack: true,
        xField: 'time',
        yField: 'value',
        yAxis: {
          title: {
            text: 'kWh',
          },
          grid: null,
        },
        seriesField: 'category',
        legend: {
          position: 'top',
        },
      });
      this.columnPlot.render();
    },
    /**
     * 创建饼图
     */
    piePlotRender() {
      this.piePlot = new Pie('container_pie', {
        data: [],
        angleField: 'value',
        colorField: 'type',
        radius: 0.9,
        label: {
          type: 'inner',
          content: ({ percent }) => `${(percent * 100).toFixed(0)}%`,
        },
        interactions: [{ type: 'element-active' }],
      });
      this.piePlot.render();
    },
    /**
     * 获取柔性指标模块数据
     */
    featchFlexibility() {
      this.gaugePlot.changeData(0.7);
      this.gaugePlot.update({
        statistic: {
          title: {
            offsetY: -5,
            style: {
              fontSize: '2rem',
            },
            formatter: () => '70.0%',
          },
        },
      });
      this.flexibility = {
        fh: '00.0',
        ps: '00.0',
        gnxt: '00.0',
        cnsb: '00.0',
      };
      getFlexibilityIndex()
        .then((res) => {})
        .catch((err) => {});
    },
    /**
     * 获取设备列表
     */
    async fetchDeviceList() {
      try {
        const response = await getDeviceList({ project_id: routerParams('project_id') });
        return response.data.filter((item) => {
          if (item.eqname !== '空调热量' && item.eqname !== '空调电量') {
            return item;
          }
        });
      } catch (error) {
        console.error('获取设备列表失败:', error);
        return []; // 返回空数组作为降级处理
      }
    },
    /**
     * 控制参数选中设备处理
     */
    handleControlSelect(value) {
      this.fetchSetting(value.EQUSID);
    },
    /**
     * 获取控制参数
     */
    fetchSetting(EQUSID) {
      getParams({ uuid: EQUSID, project_id: routerParams('project_id') })
        .then((res) => {
          if (res.data) {
            this.controlParams = {
              checked: res.data.onoff ? true : false,
              radio: res.data.speed,
              wdsd: res.data.TS,
              yxms: res.data.way,
            };
          }
        })
        .catch((err) => {});
    },
    /**
     * 重置控制参数
     */
    reset() {
      this.controlParams = {
        checked: false,
        radio: '2',
        wdsd: null,
        yxms: null,
      };
    },
    /**
     * 保存控制参数
     */
    submit() {
      this.btnLoading = true;
      const params = {
        uuid: this.controlSelect.EQUSID,
        cid: this.controlSelect.eqcode,
        kind: this.controlSelect.sortid,
        project_id: routerParams('project_id'),
        onoff: this.controlParams.checked ? 1 : 0,
        speed: this.controlParams.radio,
        TS: this.controlParams.wdsd,
        way: this.controlParams.yxms,
      };
      createParams(params)
        .then((res) => {
          if (res.data.code === 200) {
            showToast(null, '成功', '设定成功');
          }
        })
        .catch((err) => {
          showToast(null, '失败', err);
        })
        .finally(() => {
          this.btnLoading = false;
        });
    },
    switchTabs(val) {
      if (val == 1) {
        this.fields = this.roomsFields;
        this.items = this.roomsItems;
      } else {
        this.fields = this.masterFields;
        this.items = this.masterItems;
      }
    },
    /**
     * 装载数据
     * @param jsonData 列表数据
     */
    processMasterData(jsonData) {
      // 创建参数名到索引的映射
      const paramIndexMap = {};
      this.masterItems.forEach((item, index) => {
        paramIndexMap[item.params] = index;
      });

      // 遍历JSON数据，更新masterItem
      for (const [key, value] of Object.entries(jsonData)) {
        if (paramIndexMap.hasOwnProperty(key)) {
          const index = paramIndexMap[key];

          // 特殊值处理
          let processedValue = value;

          // 温度值处理（TR、TS、HR等需要除以10）
          if (['TR', 'TS', 'HR'].includes(key)) {
            processedValue = (value / 10).toFixed(1);
          }
          // 开关状态处理
          else if (key === 'onoff') {
            processedValue = value === 1 ? '开' : '关';
          }
          // 时间戳处理
          else if (key === 'timestamp') {
            const date = new Date(value);
            processedValue =
              `${date.getFullYear()}-${(date.getMonth() + 1).toString().padStart(2, '0')}-${date.getDate().toString().padStart(2, '0')} ` +
              `${date.getHours().toString().padStart(2, '0')}:${date.getMinutes().toString().padStart(2, '0')}`;
          }

          // 更新masterItem
          this.masterItems[index].num = processedValue;
        }
      }
      console.log('masterItems', this.masterItems);
    },
    /**
     *  获取列表
     */
    fetchGetList() {
      this.loading = true;
      getList({ project_id: routerParams('project_id') })
        .then((res) => {
          if (res.data) {
            this.roomsItems = res.data.room;
            // 处理主机数据
            if (res.data.Master && res.data.Master.length > 0) {
              this.processMasterData(res.data.Master[0]);
            }
            this.fields = this.roomsFields;
            this.items = this.roomsItems;
          }
        })
        .catch((err) => {})
        .finally(() => {
          this.loading = false;
        });
    },
    /**
     * 切换及时加载数据
     */
    change(val) {
      if (val) {
        this.fetchGetList();
      }
    },
    /**
     * 获取温度设定数据
     */
    fetchTemp() {
      getTemperature({ project_id: routerParams('project_id'), uuid: this.controlSelect.EQUSID })
        .then((res) => {
          const transformed = [];
          res.data.forEach((item) => {
            // 提取时间部分，只保留"HH:mm"格式
            const time = item.time.split(' ')[1].substring(0, 5);
            // 处理TR（实际温度）
            transformed.push({
              time: time,
              value: item.TR,
              category: 'actual',
            });
            // 处理TS（设定温度）
            transformed.push({
              time: time,
              value: item.TS,
              category: 'setpoint',
            });
          });
          this.linePlot && this.linePlot.changeData(transformed);
          this.linePlot &&
            this.linePlot.update({
              meta: {
                category: {
                  formatter: (value) => {
                    const map = {
                      setpoint: '设定值',
                      actual: '调优值',
                    };
                    return map[value] || value;
                  },
                },
              },
            });
        })
        .catch((err) => {
          showToast(err);
        });
    },
    /**
     * 室内环境选中设备处理
     */
    handleIndoorSelect(value) {
      this.fetchIndoorEnvironment(value.EQUSID);
      this.fetchEnvironment(value.EQUSID);
    },
    /**
     * 获取室内环境数据
     */
    fetchIndoorEnvironment(EQUSID) {
      getIndoor({ uuid: EQUSID, project_id: routerParams('project_id') })
        .then((res) => {
          if (res.data.code === 200) {
            res.data.data[0].TR && (this.indoorEnvironment.wd = (res.data.data[0].TR / 10).toFixed(1));
            res.data.data[0].HR && (this.indoorEnvironment.sd = (res.data.data[0].HR / 10).toFixed(1));
            res.data.data[0].CO2 && (this.indoorEnvironment.co2 = res.data.data[0].CO2.toFixed(1));
            res.data.data[0].PM25 && (this.indoorEnvironment.pm25 = res.data.data[0].PM25.toFixed(1));
          }
        })
        .catch((err) => {});
    },
    /**
     * 获取室外温湿度和PMV以及PPD
     */
    fetchEnvironment(EQUSID) {
      getEnvironment({ uuid: EQUSID, project_id: routerParams('project_id') })
        .then((res) => {
          if (res.data.code === 200) {
            res.data.data.pmv && (this.indoorEnvironment.pmv = Number(res.data.data.pmv).toFixed(2));
            res.data.data.ppd && (this.indoorEnvironment.ppd = Number(res.data.data.ppd).toFixed(2));
            res.data.data.comfort && (this.indoorEnvironment.comfort = res.data.data.comfort);
            res.data.data.temperature && (this.temperature = Number(res.data.data.temperature).toFixed(1));
            res.data.data.humidity && (this.humidity = Number(res.data.data.humidity).toFixed(1));
          }
        })
        .catch((err) => {});
    },
    /**
     * 获取负荷预测数据
     */
    fetchLoad() {
      const project_id = routerParams('project_id');
      store
        .dispatch('projects/fetchProjectOptimization', '7')
        .then((res) => {
          if (res.data) {
            this.areaPlot && this.areaPlot.changeData(res.data);
            let max = { egname: '', value: 0, time: '' };
            res.data.map((item) => {
              if (item.egname !== '实测值') {
                if (item.value >= max.value) {
                  max = item;
                }
              }
            });
            this.predictionMax = max;
          }
        })
        .catch((error) => {});
    },
    /**
     * 获取预测控制数据
     */
    fetchControl() {
      getControl({ project_id: routerParams('project_id') })
        .then((res) => {
          if (res.data.length) {
            const tempData = res.data.map((item) => {
              return {
                time: item.time.split(' ')[1].substring(0, 5),
                temperSet: item.temperSet ? Number(item.temperSet) : null,
                // windSpeedSet: item.windSpeedSet ? Number(item.windSpeedSet) : null,
                windSpeedSet: item.windSpeedSet ? 3 : null,
              };
            });
            const max = Math.max(...tempData.map((item) => item.temperSet));
            this.dualAxesPlot.changeData([tempData, tempData]);
            this.dualAxesPlot.update({
              yAxis: {
                temperSet: {
                  title: {
                    text: '温度设定 (℃)',
                  },
                  grid: null,
                  max: max + 5,
                  sync: true, // 关键：确保同步
                },
              },
            });
          }
        })
        .catch((err) => {});
    },
    /**
     * 获取储能调度数据
     */
    fetchStored() {
      this.storedEnergy = {
        charging: '0.00',
        discharge: '0.00',
      };
      const data = [
        { time: '00:00', value: 0, category: 'grid' },
        { time: '01:00', value: 0, category: 'grid' },
        { time: '02:00', value: 0, category: 'grid' },
        { time: '03:00', value: 0, category: 'grid' },
        { time: '04:00', value: 2, category: 'grid' },
        { time: '05:00', value: 4, category: 'grid' },
        { time: '06:00', value: 5, category: 'grid' },
        { time: '07:00', value: 7, category: 'grid' },
        { time: '08:00', value: 5, category: 'grid' },
        { time: '09:00', value: 4, category: 'grid' },
        { time: '10:00', value: 3, category: 'grid' },
        { time: '11:00', value: 2, category: 'grid' },
        { time: '12:00', value: 1, category: 'grid' },
        { time: '13:00', value: 0, category: 'grid' },
        { time: '14:00', value: 0, category: 'grid' },
        { time: '15:00', value: 0, category: 'grid' },
        { time: '16:00', value: 0, category: 'grid' },
        { time: '17:00', value: 1, category: 'grid' },
        { time: '18:00', value: 2, category: 'grid' },
        { time: '19:00', value: 3, category: 'grid' },
        { time: '20:00', value: 5, category: 'grid' },
        { time: '21:00', value: 3, category: 'grid' },
        { time: '22:00', value: 2, category: 'grid' },
        { time: '23:00', value: 1, category: 'grid' },
        { time: '00:00', value: 0, category: 'pv' },
        { time: '01:00', value: 0, category: 'pv' },
        { time: '02:00', value: 0, category: 'pv' },
        { time: '03:00', value: 0, category: 'pv' },
        { time: '04:00', value: 0, category: 'pv' },
        { time: '05:00', value: 0, category: 'pv' },
        { time: '06:00', value: 0, category: 'pv' },
        { time: '07:00', value: 0, category: 'pv' },
        { time: '08:00', value: 4, category: 'pv' },
        { time: '09:00', value: 8, category: 'pv' },
        { time: '10:00', value: 10, category: 'pv' },
        { time: '11:00', value: 12, category: 'pv' },
        { time: '12:00', value: 14, category: 'pv' },
        { time: '13:00', value: 16, category: 'pv' },
        { time: '14:00', value: 18, category: 'pv' },
        { time: '15:00', value: 18, category: 'pv' },
        { time: '16:00', value: 16, category: 'pv' },
        { time: '17:00', value: 14, category: 'pv' },
        { time: '18:00', value: 10, category: 'pv' },
        { time: '19:00', value: 6, category: 'pv' },
        { time: '20:00', value: 0, category: 'pv' },
        { time: '21:00', value: 0, category: 'pv' },
        { time: '22:00', value: 0, category: 'pv' },
        { time: '23:00', value: 0, category: 'pv' },
        { time: '00:00', value: 4, category: 'battery' },
        { time: '01:00', value: 5, category: 'battery' },
        { time: '02:00', value: 6, category: 'battery' },
        { time: '03:00', value: 7, category: 'battery' },
        { time: '04:00', value: 6, category: 'battery' },
        { time: '05:00', value: 5, category: 'battery' },
        { time: '06:00', value: 4, category: 'battery' },
        { time: '07:00', value: 3, category: 'battery' },
        { time: '08:00', value: 2, category: 'battery' },
        { time: '09:00', value: 1, category: 'battery' },
        { time: '10:00', value: 0, category: 'battery' },
        { time: '11:00', value: 0, category: 'battery' },
        { time: '12:00', value: 0, category: 'battery' },
        { time: '13:00', value: 0, category: 'battery' },
        { time: '14:00', value: 0, category: 'battery' },
        { time: '15:00', value: 0, category: 'battery' },
        { time: '16:00', value: 0, category: 'battery' },
        { time: '17:00', value: 0, category: 'battery' },
        { time: '18:00', value: 2, category: 'battery' },
        { time: '19:00', value: 3, category: 'battery' },
        { time: '20:00', value: 4, category: 'battery' },
        { time: '21:00', value: 5, category: 'battery' },
        { time: '22:00', value: 6, category: 'battery' },
        { time: '23:00', value: 5, category: 'battery' },
      ];
      this.columnPlot.changeData(data);
      this.columnPlot.update({
        meta: {
          category: {
            formatter: (value) => {
              const map = {
                grid: '市电',
                pv: '光伏',
                battery: '储能',
              };
              return map[value] || value;
            },
          },
        },
      });
      return;
      getStored()
        .then((res) => {})
        .catch((err) => {});
    },
    /**
     * 获取优化成效数据
     */
    fetchOptimizing() {
      this.optimizing = {
        conservation: '0.00',
        adjust: '0.00',
      };
      const data = [
        { type: '空调', value: 27 },
        { type: '通风', value: 25 },
        { type: '照明', value: 18 },
      ];
      return;
      this.piePlot.changeData(data);
      getOptimizing()
        .then((res) => {})
        .catch((err) => {});
    },
  },
  async created() {
    // this.fetchGetList();
    this.deviceList = await this.fetchDeviceList();
    if (this.deviceList.length > 0) {
      this.controlSelect = this.deviceList[0];
      this.indoorSelect = this.deviceList[0];
      this.fetchIndoorEnvironment(this.deviceList[0].EQUSID);
      this.fetchEnvironment(this.deviceList[0].EQUSID);
      this.fetchSetting(this.deviceList[0].EQUSID);
    }
    // this.featchFlexibility();
    this.fetchTemp();
    this.fetchLoad();
    this.fetchControl();
    // this.fetchStored();
  },
  mounted() {
    this.linePlotRender();
    this.areaPlotRender();
    // this.gaugePlotRender();
    this.dualAxesPlotRender();
    // this.columnPlotRender();
    // this.piePlotRender();
  },
};
</script>

<style lang="scss" scoped>
.custom_table {
  height: 25rem;
  overflow: hidden;
  position: relative;
  ::v-deep .table {
    th,
    td {
      padding: 0.5rem 0.5rem;
    }
  }
}
.temp_inp {
  .form-control {
    border-right: 0;
  }
  .disabled_custom {
    border-top-right-radius: 0.357rem;
    border-bottom-right-radius: 0.357rem;
    .input-group-text {
      background-color: #efefef;
    }
  }
}
.dark-layout .temp_inp .input-group-text {
  border-color: #414657;
}
.dark-layout .temp_inp .disabled_custom .input-group-text {
  background-color: #283046 !important;
  border-color: #353b4f;
  color: #717989;
}
.mt2 {
  margin-top: 2rem;
}

.custom_alert {
  .alert .alert-body {
    padding: 0.4rem 1rem;
  }
}

.select {
  width: 180px;
  position: absolute;
  top: 13px;
  right: 21px;
}

.alert .alert-body svg {
  position: relative;
  top: 0px;
}
</style>
